import { render, staticRenderFns } from "./AskForRefund.vue?vue&type=template&id=dc858018&scoped=true&"
import script from "./AskForRefund.vue?vue&type=script&lang=js&"
export * from "./AskForRefund.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc858018",
  null
  
)

export default component.exports